import { useState } from 'react';

import { useForm } from 'react-hook-form';

import useMobile from '../../../hooks/useMobile';
import Button from '../../atoms/button/button';
import Checkbox from '../../atoms/checkbox/checkbox';
import ControlSecurity from '../../atoms/control-security/controlSecurity';
import Input from '../../atoms/input/input';
import './boletinSubscriptionForm.scss';

interface BoletinForm {
  inputReferences: any;
  setBulletinModal: Function;
}

const BoletinSubscriptionForm = (props: BoletinForm) => {
  const { inputReferences, setBulletinModal } = props;
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
    watch,
    setError,
    clearErrors,
  } = useForm();
  const mobile = useMobile();
  const [termsCheck, setTermsCheck] = useState(false);
  const [pasedControl, setPasedControl] = useState(false);
  const watchNames = watch('names');
  const watchSurNames = watch('surNames');
  const watchEmail = watch('email');
  const watchEmailConfirmation = watch('emailConfirmation');

  const onSubmit = (data) => {
    if (data && pasedControl) {
      setBulletinModal(true);
    }
  };

  return (
    <div className="m-boletinSubscriptionForm">
      <div className="m-boletinSubscriptionForm__container">
        <div className="m-boletinSubscriptionForm__container__header">
          <h2>{inputReferences.titulo}</h2>
          <p>{inputReferences.subtitulo}</p>
        </div>
        <div className="m-boletinSubscriptionForm__container__form">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="m-boletinSubscriptionForm__container__division" />
            <div className="m-boletinSubscriptionForm__container__form__inputs">
              <div className="m-boletinSubscriptionForm__container__form__inputs__right">
                <Input
                  label={
                    inputReferences.referencias[0].titulo
                      ? inputReferences.referencias[0].titulo
                      : 'Nombres'
                  }
                  name="names"
                  maxLength="25"
                  type="text"
                  square
                  placeholder={
                    inputReferences.referencias[0].subtitulo
                      ? inputReferences.referencias[0].subtitulo
                      : 'Escribe tus nombres'
                  }
                  register={register}
                  validationRules={{
                    required: {
                      value: true,
                      message: 'Campo requerido',
                    },
                    pattern: {
                      value: /^[A-Za-zÀ-ÿ ,.'-]+$/,
                      message: 'No se permiten caracteres especiales',
                    },
                    minLength: {
                      value: 2,
                      message: 'El nombre debe tener al menos 2 caracteres',
                    },
                  }}
                  setValue={setValue}
                  required
                  error={errors.names}
                />
                {mobile ? (
                  <Input
                    label={inputReferences?.referencias?.[1]?.titulo || 'Apellidos'}
                    name="surNames"
                    maxLength="25"
                    type="text"
                    square
                    placeholder={
                      inputReferences?.referencias?.[1]?.subtitulo || 'Escribe tus Apellidos'
                    }
                    register={register}
                    validationRules={{
                      required: {
                        value: true,
                        message: 'Campo requerido',
                      },
                      pattern: {
                        value: /^[A-Za-zÀ-ÿ ,.'-]+$/,
                        message: 'No se permiten caracteres especiales',
                      },
                      minLength: {
                        value: 2,
                        message: 'El apellido debe tener al menos 2 caracteres',
                      },
                    }}
                    setValue={setValue}
                    required
                    error={errors.surNames}
                  />
                ) : (
                  <Input
                    label={inputReferences?.referencias?.[2]?.titulo || 'Correo electrónico'}
                    name="email"
                    maxLength="50"
                    type="email"
                    square
                    placeholder={
                      inputReferences?.referencias?.[2]?.subtitulo ||
                      'Escribe tu correo electrónico'
                    }
                    register={register}
                    validationRules={{
                      required: {
                        value: true,
                        message: 'Campo requerido',
                      },
                      pattern: {
                        value:
                          /^(([^<>()[\]\\.,;:=\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        message: 'Debe cumplir con la estructura de un correo',
                      },
                      maxLength: {
                        value: 50,
                        message: 'El correo no debe superar los 50 dígitos',
                      },
                      minLength: {
                        value: 4,
                        message: 'El correo debe tener al menos 4 dígitos',
                      },
                    }}
                    setValue={setValue}
                    required
                    error={errors.email}
                  />
                )}
              </div>
              <div className="m-boletinSubscriptionForm__container__form__inputs__left">
                {mobile ? (
                  <Input
                    label={inputReferences?.referencias?.[2]?.titulo || 'Correo electrónico'}
                    name="email"
                    maxLength="50"
                    type="email"
                    square
                    placeholder={
                      inputReferences?.referencias?.[2]?.subtitulo ||
                      'Escribe tu correo electrónico'
                    }
                    register={register}
                    validationRules={{
                      required: {
                        value: true,
                        message: 'Campo requerido',
                      },
                      pattern: {
                        value:
                          /^(([^<>()[\]\\.,;:=\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        message: 'Debe cumplir con la estructura de un correo',
                      },
                      maxLength: {
                        value: 50,
                        message: 'El correo no debe superar los 50 dígitos',
                      },
                      minLength: {
                        value: 4,
                        message: 'El correo debe tener al menos 4 dígitos',
                      },
                    }}
                    setValue={setValue}
                    required
                    error={errors.email}
                  />
                ) : (
                  <Input
                    label={inputReferences?.referencias?.[1]?.titulo || 'Apellidos'}
                    name="surNames"
                    maxLength="25"
                    type="text"
                    square
                    placeholder={
                      inputReferences?.referencias?.[1]?.titulo || 'Escribe tus Apellidos'
                    }
                    register={register}
                    validationRules={{
                      required: {
                        value: true,
                        message: 'Campo requerido',
                      },
                      pattern: {
                        value: /^[A-Za-zÀ-ÿ ,.'-]+$/,
                        message: 'No se permiten caracteres especiales',
                      },
                      minLength: {
                        value: 2,
                        message: 'El apellido debe tener al menos 2 caracteres',
                      },
                    }}
                    setValue={setValue}
                    required
                    error={errors.surNames}
                  />
                )}
                <Input
                  label={
                    inputReferences.referencias[3].titulo
                      ? inputReferences.referencias[3].titulo
                      : 'Confirmación correo electrónico *'
                  }
                  name="emailConfirmation"
                  maxLength="50"
                  type="email"
                  square
                  placeholder={
                    inputReferences.referencias[3].subtitulo
                      ? inputReferences.referencias[3].subtitulo
                      : 'Confirma tu correo electrónico'
                  }
                  register={register}
                  validationRules={{
                    required: {
                      value: true,
                      message: 'Campo requerido',
                    },
                    pattern: {
                      value:
                        /^(([^<>()[\]\\.,;:=\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      message: 'Debe cumplir con la estructura de un correo',
                    },
                    maxLength: {
                      value: 50,
                      message: 'El correo no debe superar los 50 dígitos',
                    },
                    minLength: {
                      value: 4,
                      message: 'El correo debe tener al menos 4 dígitos',
                    },
                  }}
                  onChange={(e) => {
                    if (watchEmail !== e.target.value) {
                      setError('emailConfirmation', {
                        type: 'custom',
                        message: 'El email no coincide',
                      });
                    } else {
                      clearErrors();
                    }
                  }}
                  setValue={setValue}
                  required
                  error={errors.emailConfirmation}
                />
              </div>
            </div>
            <div className="m-boletinSubscriptionForm__container__division" />
            <div className="m-boletinSubscriptionForm__container__form__validations">
              <div className="m-boletinSubscriptionForm__container__form__validations__securityControl">
                <ControlSecurity setValidation={setPasedControl} />
              </div>
              <div className="m-boletinSubscriptionForm__container__form__validations__terms">
                <p>{inputReferences.secciones[1].subtitulo}</p>
                <div className="m-boletinSubscriptionForm__container__form__validations__terms__checkbox">
                  <Checkbox
                    checkActive={termsCheck}
                    square
                    checkClick={() => setTermsCheck(!termsCheck)}
                  />
                  <p>{inputReferences.secciones[1].titulo}</p>
                </div>
              </div>
            </div>
            <div className="m-boletinSubscriptionForm__container__form__button">
              <Button
                type="button"
                classname="secondary"
                text={inputReferences.boton[0].copy}
                isDisabled={
                  !(
                    watchEmail &&
                    watchNames &&
                    watchEmail === watchEmailConfirmation &&
                    watchSurNames &&
                    termsCheck &&
                    pasedControl
                  )
                }
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BoletinSubscriptionForm;
